import React, { useState } from "react";
import API_URL from "../config";
import "../styles/Formularios.css";
import { useGlobal } from "../context/ContenedorGlobal";
import InputGenerico from "./InputGenerico";
import InputContrasena from "./InputContrasena";

function CompletarRegistro() {

    const { setModuloActual, setSubModuloActual } = useGlobal();
    const [idTecnico, setIdTecnico] = useState("");
    const [codigoTemp, setCodigoTemp] = useState("");
    const [contrasena, setContrasena] = useState("");
    const [contrasenaConfirmacion, setContrasenaConfirmacion] = useState("");
    const [error, setError] = useState("");
    const [successMessage, setSuccessMessage] = useState("");

    // Regex para contraseña
    const regexPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;

    const validarInputs = () => {
        // Validar que todos los campos tengan datos
        if (!idTecnico || !codigoTemp || !contrasena || !contrasenaConfirmacion) {
            return "Todos los campos son obligatorios.";
        }

        // Validación del número de empleado
        if (!/^\d{7}$/.test(idTecnico)) {
            return "El número de empleado debe contener exactamente 7 dígitos.";
        }

        // Validación del código temporal
        if (!/^[A-Z0-9]{6}$/.test(codigoTemp)) {
            return "El código de registro debe tener exactamente 6 caracteres alfanuméricos (A-Z, 0-9).";
        }

        // Validación de contraseña con regex
        if (!regexPassword.test(contrasena)) {
            return "La contraseña debe tener mínimo 8 caracteres, incluir mayúscula, minúscula, número y carácter especial.";
        }

        // Confirmación de contraseña
        if (contrasena !== contrasenaConfirmacion) {
            return "Las contraseñas no coinciden.";
        }

        return null; // Todo correcto
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setSuccessMessage("");

        const err = validarInputs();
        if (err) {
            setError(err);

            // Limpiar el error después de 3 segundos
            setTimeout(() => {
                setError("");
            }, 3000);

            return;
        }

        try {
            const response = await fetch(`${API_URL}/completar_registro.php`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    id_tecnico: idTecnico,
                    codigo_temp: codigoTemp.toUpperCase(),
                    contrasena: contrasena,
                    contrasena_confirmacion: contrasenaConfirmacion,
                }),
            });

            const data = await response.json();

            if (data.status === "ok") {
                setSuccessMessage("Registro completado. Ahora puede iniciar sesión.");
                setTimeout(() => {
                    setModuloActual("Autenticación");
                    setSubModuloActual("Iniciar sesión");
                }, 3000);
            } else {
                if (data.message === "El técnico ya está registrado. No puede completar el registro nuevamente.") {
                    // Caso: técnico ya registrado
                    setSuccessMessage("El técnico ya está registrado. Use la opción de iniciar sesión.");
                    setTimeout(() => {
                        setModuloActual("Autenticación");
                        setSubModuloActual("Iniciar sesión");
                    }, 3000);
                } else {
                    // Otros errores
                    setError(data.message || "Error al procesar la solicitud.");

                    // Limpiar el error después de 3 segundos
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                }
            }
        } catch (err) {
            setError("Error de conexión con el servidor.");

            // Limpiar el error después de 3 segundos
            setTimeout(() => {
                setError("");
            }, 3000);
        }
    };

    return (
        <div className="sesion-form">
            <>
                {error && <div className="error">{error}</div>}
            </>
            {!successMessage && (

                <form onSubmit={handleSubmit}>

                    <InputGenerico
                        value={idTecnico}
                        setValue={setIdTecnico}
                        label="Número de empleado"
                        maxLength={7}
                        allowedChars="0-9"
                        placeholder="7120000"
                        title="Debe contener exactamente 7 dígitos"
                    />

                    <InputGenerico
                        value={codigoTemp}
                        setValue={setCodigoTemp}
                        label="Código de registro"
                        maxLength={6}
                        allowedChars="0-9A-Z"
                        transform="uppercase"
                        placeholder="A1B2C3"
                        title="Debe contener exactamente 6 caracteres alfanuméricos"
                    />

                    <InputContrasena
                        contrasena={contrasena}
                        setContrasena={setContrasena}
                        label="Contraseña"
                    />
                    <InputContrasena
                        contrasena={contrasenaConfirmacion}
                        setContrasena={setContrasenaConfirmacion}
                        label="Confirmar contraseña"
                    />

                    <div className="form-buttons">
                        <button type="submit">Completar registro</button>
                    </div>

                </form>
            )}

            {successMessage && (

                <div className="success">
                    <p>{successMessage}</p>
                </div>
            )}

        </div>
    );
}

export default CompletarRegistro;